import React from "react";
import { SafeOperatingSpace } from "./Spaces/SafeOperatingSpace";
import { HighRiskSpace } from "./Spaces/HighRiskSpace";
import HighRiskMarker from "./Marker/HighRiskMarker";
import { PlanetaryBoundaryMarker } from "./Marker/PlanetaryBoundaryMarker";
import { BoundaryBarMarker } from "./Marker/BoundaryBarMarker";
import { DottedLine } from "./Lines/DottedLine";

interface BoundaryBarProps {
  markerPercent?: number;
  name?: string;
  nameLabel?: string;
  showLeftArrows?: boolean;
  showRightArrows?: boolean;
  dottedLine?: [number, number]; // [startPercent, endPercent]
}

export const BoundaryBar: React.FC<BoundaryBarProps> = ({
  markerPercent = 0,
  name = "",
  nameLabel,
  showLeftArrows = false,
  showRightArrows = false,
  dottedLine,
}) => (
  <div className="boundary-bar">
    {name && (
      <div className="boundary-bar__header">
        {name}
        {nameLabel && <span className="boundary-bar__label">{nameLabel}</span>}
      </div>
    )}
    <div className="boundary-bar__chart">
      <PlanetaryBoundaryMarker height={20} />

      <HighRiskMarker height={20} />

      <SafeOperatingSpace height={20} />
      <HighRiskSpace height={20} />
      {/* DottedLine wird angezeigt, wenn dottedLine-Prop gesetzt ist */}
      {dottedLine && (
        <DottedLine startPercent={dottedLine[0]} endPercent={dottedLine[1]} />
      )}
      <BoundaryBarMarker
        markerPercent={markerPercent}
        showLeftArrows={showLeftArrows}
        showRightArrows={showRightArrows}
      />
    </div>
  </div>
);
